export default __webpack_public_path__ + "03d320041c75bbebc3a6d629e8ce1299.svg";